import React, { useEffect, useState, useCallback, useContext } from "react";
import QuoteDetailsHeader from "./QuoteDetailsHeader";
import { useLoaderData, json } from "react-router-dom";
import ItemList from "../Items/ItemList";
import styles from "./QuoteDetails.module.css";
import RequestForQuote from "../RFQ/RequestForQuote";
import { useParams } from "react-router-dom";
import useHttp from "../../hooks/use-http";
import { useNavigate } from "react-router-dom";
import AppContext from "../../store/app-context";
import { parseCookies } from "nookies";

const QuoteDetails = (props) => {
  const [quote, setQuote] = useState();
  const { webRef } = useParams();
  const {
    isLoadingGetQuote,
    errorGetQuote,
    sendRequest: getQuoteDetails,
  } = useHttp();
  const [isLoading, setIsLoading] = useState(true);
  const [isAPIError, setIsAPIError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error fetching data...");
  const [destWebRef, setDestWebRef] = useState();

  sessionStorage.removeItem("submittedWebRef");

  const navigate = useNavigate();

  const appCtx = useContext(AppContext);

  let label_expiredQuote = 'This quote has expired.';
  let label_expiredRenew = 'If you are still interested in the items on this list, you have the option to renew the quote and extend the expiration date.';
  let label_expiredCopy = 'If you are still interested in the items on this list, you can submit a new quote for the latest pricing available to you.';
  let label_quoteSubmittedRenewal = 'Quote submitted for renewal';
  const existCookies = parseCookies();
  let newBrandStyle
  if(appCtx && appCtx.bioradResources){
    label_expiredQuote = appCtx.bioradResources.Expired_For_Quote_Request_Msg ? appCtx.bioradResources.Expired_For_Quote_Request_Msg : 'This quote has expired.';
    label_expiredRenew = appCtx.bioradResources.Resubmit_For_Quote_Request_Msg ? appCtx.bioradResources.Resubmit_For_Quote_Request_Msg : 'If you are still interested in the items on this list, you have the option to renew the quote and extend the expiration date.';
    label_expiredCopy = appCtx.bioradResources.Copy_To_New_Quote_Request_Msg ? appCtx.bioradResources.Copy_To_New_Quote_Request_Msg : 'If you are still interested in the items on this list, you can submit a new quote for the latest pricing available to you.';
    label_quoteSubmittedRenewal = appCtx.bioradResources.Quote_Submitted_Renewal ? appCtx.bioradResources.Quote_Submitted_Renewal : 'Quote submitted for renewal';
  }
  useEffect(() =>{
    if(appCtx && appCtx.envProp){
    newBrandStyle = existCookies.rebrandEnabled
      ? existCookies.rebrandEnabled
      : appCtx.envProp.react_app_new_brand_style ? appCtx.envProp.react_app_new_brand_style : false;
    }

  },[appCtx])
  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      setIsLoading(false);
    };

    if(props?.quote){
      setQuoteData(props.quote);
    }else{
      setIsLoading(true);
      //getQuoteHandler();
      getQuoteDetails(
        { url: "/quoteservices/rfqs/rfq/" + webRef },
        setQuoteData,
        "json"
      ).catch((error) => {
        if (error && error.message) {
          setErrorMsg(error.message);
        }
        setIsAPIError(true);
        setIsLoading(false);
      });
    }
    //setIsLoading(false);
  }, []);

  const copyQuoteHandler = useCallback(async () => {
    setIsLoading(true);

    const setDestinationWebRef = (data) => {
      setDestWebRef(data);
    }

    const copyURL = "/quoteservices/rfqs/copy/" + webRef;
    const response = await fetch(copyURL, { method: 'GET'} );

    if (!response.ok) {
      const data = await response.json();
      if(data && data.status === 'fail'){
        setErrorMsg(data.message);
      }
      setIsLoading(false);
    }else{
      const data = await response.json();
      if(data && data.status === 'fail'){
        setErrorMsg(data.message);
      }else{
        setDestinationWebRef(data);
      }
    }
    setIsLoading(false);
  },[])

  const renewQuoteHandler = useCallback(async () => {
    setIsLoading(true);

    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      setIsLoading(false);
    };

    const copyURL = "/quoteservices/rfqs/renew/" + webRef;
    const response = await fetch(copyURL, { method: 'GET'} );

    if (!response.ok) {
      const data = await response.json();
      if(data && data.status === 'fail'){
        setErrorMsg(data.message);
      }
      setIsLoading(false);
    }else{
      const data = await response.json();
      if(data && data.status === 'fail'){
        setErrorMsg(data.message);
      }else{
        setQuoteData(data);
        if (newBrandStyle === 'true' && data.quoteId) {
          const deleteNotificationURL = appCtx.envProp.appServer+"etlapi/my-biorad/delete-renewed-quote-notification/quote/"+data.quoteId+"/type/Expired";
          await fetch(deleteNotificationURL, { method: 'DELETE' });
        }

      }
    }
    setIsLoading(false);
  },[appCtx])

  //If copy clicked then redirect to RFQ home with new rfq id.
  if(destWebRef) {
    navigate('/'+destWebRef);
  }

  //if open quote then redirect to RFQ home
  if(quote?.quoteStatus && quote.quoteStatus ==='Not Submitted'){
    navigate('/'+webRef);
  }

  const isRenewed = quote && (quote.quoteStatus==='Pending Renewal') ? true : false;

  return (
    <>
      <div className={styles.quote__headerMod}>
        {isRenewed && (<div className={styles.infoBox}><span className={styles.bioicons_circle_exclamation}></span><p>{label_quoteSubmittedRenewal}</p></div>)}
        {isAPIError && <p>{errorMsg}</p>}
        {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
        {!isLoading && !isAPIError && (
          <>
            {quote.isExpired && quote.isRenewable && (
              <div className={styles.infoBox}>
                <span className={styles.bioicons_circle_exclamation}></span>
                <p>
                  <span><strong>{label_expiredQuote}</strong> {label_expiredRenew}</span>
                </p>
              </div>
            )}
            {quote.isExpired && !quote.isRenewable && (
              <div className={styles.infoBox}>
                <span className={styles.bioicons_circle_exclamation}></span>
                <p>
                  <span><strong>{label_expiredQuote}</strong> {label_expiredCopy}</span>
                </p>
              </div>
            )}

            <QuoteDetailsHeader quote={quote} />
            <div className={styles.cart_os_module}>
              <div className={styles.cart_module}>
                {quote &&
                  quote.quoteLineEntityList &&
                  quote.quoteLineEntityList.length > 0 && (
                    <ItemList quote={quote} isEditable={false} />
                  )}
              </div>
              <div className="right-col-wrapper">
                <RequestForQuote
                  total={
                    quote && quote.formattedTotalPrice
                      ? quote.formattedTotalPrice
                      : ""
                  }
                  isEditable={false}
                  quote={quote ? quote : null}
                  copyQuoteHandler={copyQuoteHandler}
                  renewQuoteHandler={renewQuoteHandler}
                  isRenewed = {isRenewed}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default QuoteDetails;

export async function loader({ request, params }) {
  const webRef = params.webRef;

  const response = await fetch("/quoteservices/rfqs/rfq/" + webRef);

  if (!response.ok) {
    throw json(
      { message: "Could not fetch details for selected quote." },
      {
        status: 500,
      }
    );
  } else {
    return response;
  }
}
